import React from 'react';
import PropTypes from 'prop-types';
import { V2CausesIcon } from '@paypalcorp/pp-react-icons';
import { isGN } from '../../utility/externalIntegrationUtils';

const bannerType = {
  logoBanner: 'logo-banner', // Styles for banner with logo or Avatar
  banner: 'banner', // Styles for banner without logo or avatar
};

const BannerHeader = ({ type, children }) => {
  return <div className={bannerType[type]}>{children}</div>;
};

export const Banner = ({ bannerURL }) => {
  return (
    <section
      className="banner-img"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0) 50%), url(${bannerURL})`,
      }}
    />
  );
};

export const Avatar = ({ logoURL, initialLogo, initialColor }) => {
  if (logoURL !== '') {
    return <ImgLogo logoURL={logoURL} />;
  }
  if (isGN()) {
    return (
      <InititalsLogo initialLogo={initialLogo} initialColor={initialColor} />
    );
  }
  return <IconLogo />;
};

const ImgLogo = ({ logoURL }) => {
  return (
    <div className="avatar-rounded-container">
      <img className="avatar" src={logoURL} aria-hidden="true" />
    </div>
  );
};

const InititalsLogo = ({ initialLogo, initialColor }) => {
  return (
    <div
      className={`avatar-rounded-container avatar-logo logo-${initialColor}-bg`}
      aria-hidden="true"
    >
      <span className="logo-initials">{initialLogo}</span>
    </div>
  );
};

const IconLogo = () => {
  return (
    <div
      className="avatar-rounded-container avatar-logo logo-pink-bg"
      aria-hidden="true"
    >
      <V2CausesIcon className="logo-icon" />
    </div>
  );
};

BannerHeader.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Avatar.propTypes = {
  logoURL: PropTypes.string,
  initialLogo: PropTypes.string,
  initialColor: PropTypes.string,
};

Banner.propTypes = {
  bannerURL: PropTypes.string,
};

ImgLogo.propTypes = {
  logoURL: PropTypes.string,
};

InititalsLogo.propTypes = {
  initialLogo: PropTypes.string,
  initialColor: PropTypes.string,
};

export default BannerHeader;
